import { AdminApiService } from '../services/general';
import type { PromptUpdate, PromptCreate } from '../services/general';

export type GetPromptsFilters = {
  promptType?: string | null;
  campaignId?: string | null;
  isActive?: string | null;
};

export const getPrompts = (
  filters: GetPromptsFilters,
  page: PaginationType
) => {
  return AdminApiService.getPromptsApiAdminPromptsGet(
    filters?.promptType,
    filters?.campaignId,
    filters?.isActive,

    page?.limit,
    page?.offset
  );
};

export const addPrompt = (payload: PromptCreatePayload) => {
  return AdminApiService.createPromptApiAdminPromptsPost({
    ...payload,
    is_active: String(payload.is_active),
  });
};

export const updatePrompt = (id: string, payload: PromptUpdatePayload) => {
  return AdminApiService.updatePromptApiAdminPromptsPromptIdPatch(id, {
    ...payload,
    is_active: String(payload.is_active),
  });
};

export const deletePrompt = (id: string) => {
  return AdminApiService.deletePromptApiAdminPromptsPromptIdDelete(id);
};

export type { PromptResponse as PromptsItem } from '../services/general';
export type PromptUpdatePayload = PromptUpdate;
export type PromptCreatePayload = PromptCreate;
